import { A } from "@solidjs/router";

export function NotFoundPage() {
  return (
    <div class="flex flex-col items-center gap-2 py-24 text-center">
      <div class="text-4xl font-semibold">404</div>
      <p class="text-muted-foreground text-sm">There is nothing here.</p>
      <A href="/" class="text-sm underline underline-offset-4">
        Back to devices
      </A>
    </div>
  );
}
